'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var react = require('@chakra-ui/react');
var DropdownIndicator = require('../components/DropdownIndicator.js');
var LoadingIndicator = require('../components/LoadingIndicator.js');
var ClearIndicator = require('../components/ClearIndicator.js');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty__default["default"](target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
// Custom component definition
var components = {
  IndicatorSeparator: null,
  DropdownIndicator: DropdownIndicator["default"],
  LoadingIndicator: LoadingIndicator["default"],
  ClearIndicator: ClearIndicator["default"]
};

/**
 * Default `react-select` props / configuration shared among all `Select` components
 */
var getReactSelectConfiguration = function getReactSelectConfiguration(_ref) {
  var size = _ref.size,
    variant = _ref.variant,
    isInvalid = _ref.isInvalid,
    _theme = _ref.theme;
  var globalThemePlaceholderColor = 'var(--hg-colors-placeholder-color)';
  var inputThemeObject = _theme.components.Input;
  var inputBaseStyle = inputThemeObject.baseStyle.field;
  var inputDefaultStyle = inputThemeObject.variants["default"](_theme).field;
  var inputFloatingStyle = inputThemeObject.variants.floating({
    theme: _theme
  }).field;
  var inputSizeStyle = function inputSizeStyle(s) {
    return inputThemeObject.sizes[s].field;
  };
  return {
    // Don't open menu when there are no options.
    noOptionsMessage: function noOptionsMessage() {
      return null;
    },
    loadingMessage: function loadingMessage() {
      return null;
    },
    isClearable: true,
    components: components,
    styles: {
      // The "input" (or at least the part that looks like an input)
      control: function control(provided, state) {
        var baseStyles = {
          display: 'flex',
          transitionProperty: inputDefaultStyle.transitionProperty,
          transitionDuration: inputBaseStyle.transitionDuration,
          borderRadius: inputDefaultStyle.borderRadius,
          background: 'white',
          h: inputSizeStyle(size).h
        };
        var invalidStyles = {
          borderStyle: 'solid',
          borderColor: 'red.400',
          borderWidth: 1,
          boxShadow: state.isFocused && 'outline-red'
        };
        switch (variant) {
          case 'floating':
            return react.css(_objectSpread(_objectSpread(_objectSpread({}, inputFloatingStyle), baseStyles), {}, {
              boxShadow: state.isFocused ? inputFloatingStyle._focus.boxShadow : inputFloatingStyle.boxShadow
            }, isInvalid && invalidStyles))(_theme);
          default:
            return react.css(_objectSpread(_objectSpread(_objectSpread({}, inputDefaultStyle), baseStyles), {}, {
              borderColor: state.isFocused ? inputDefaultStyle._focus.borderColor : inputDefaultStyle.borderColor
            }, isInvalid && invalidStyles))(_theme);
        }
      },
      // Indicators
      indicatorsContainer: function indicatorsContainer(provided) {
        return react.css(_objectSpread(_objectSpread({}, provided), {}, {
          overflow: 'hidden',
          px: 3.5
        }))(_theme);
      },
      dropdownIndicator: function dropdownIndicator(provided, state) {
        return react.css(_objectSpread(_objectSpread({}, provided), {}, {
          py: 0,
          px: 0,
          color: 'gray.400',
          transform: state.selectProps.menuIsOpen && 'rotate(180deg)',
          transformOrigin: 'center',
          transition: '200ms transform',
          ml: 1
        }))(_theme);
      },
      clearIndicator: function clearIndicator(provided) {
        return react.css(_objectSpread(_objectSpread({}, provided), {}, {
          color: 'gray.400',
          py: 0,
          px: 1.5
        }))(_theme);
      },
      // "Value" (placeholder, invisible input and a chosen value)
      valueContainer: function valueContainer(provided) {
        return react.css(_objectSpread(_objectSpread({}, provided), {}, {
          padding: 0,
          px: inputSizeStyle(size).px
        }))(_theme);
      },
      placeholder: function placeholder(provided) {
        return react.css(_objectSpread(_objectSpread({}, provided), {}, {
          m: 0,
          color: globalThemePlaceholderColor,
          fontFamily: inputBaseStyle.fontFamily,
          fontSize: inputSizeStyle(size).fontSize
        }))(_theme);
      },
      input: function input(provided) {
        return react.css(_objectSpread(_objectSpread({}, provided), {}, {
          m: 0,
          p: 0,
          color: inputBaseStyle.color,
          fontFamily: inputBaseStyle.fontFamily,
          fontSize: inputSizeStyle(size).fontSize
        }))(_theme);
      },
      singleValue: function singleValue(provided) {
        return react.css(_objectSpread(_objectSpread({}, provided), {}, {
          transition: '200ms color',
          m: 0,
          p: 0,
          color: isInvalid ? 'red.400' : inputBaseStyle.color,
          fontFamily: inputBaseStyle.fontFamily,
          fontSize: inputSizeStyle(size).fontSize
        }))(_theme);
      },
      // Dropdown
      menu: function menu(provided) {
        var baseStyles = _objectSpread(_objectSpread({}, provided), {}, {
          marginTop: 3,
          zIndex: 'dropdown'
        });
        switch (variant) {
          case 'floating':
            return react.css(_objectSpread(_objectSpread({}, baseStyles), {}, {
              boxShadow: 'sm',
              borderRadius: 'default'
            }))(_theme);
          default:
            return react.css(_objectSpread(_objectSpread({}, baseStyles), {}, {
              borderRadius: 'sm',
              border: 1,
              borderStyle: 'solid',
              borderColor: 'gray.200',
              boxShadow: 'none'
            }))(_theme);
        }
      },
      menuList: function menuList(provided) {
        return react.css(_objectSpread(_objectSpread({}, provided), {}, {
          py: 0
        }))(_theme);
      },
      option: function option(provided, state) {
        return react.css(_objectSpread(_objectSpread({}, provided), {}, {
          borderBottom: 1,
          borderBottomStyle: 'solid',
          borderBottomColor: 'gray.100',
          backgroundColor: function backgroundColor() {
            if (state.isSelected) {
              return 'blue.400';
            }
            if (state.isFocused) {
              return 'gray.100';
            }
            return 'white';
          },
          fontFamily: inputBaseStyle.fontFamily,
          fontSize: inputSizeStyle(size).fontSize,
          px: inputSizeStyle(size).px,
          py: inputSizeStyle(size).py,
          color: state.isSelected ? 'white' : 'gray.500'
        }))(_theme);
      }
    },
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    theme: function theme(reactSelectTheme) {
      return _objectSpread(_objectSpread({}, reactSelectTheme), {}, {
        borderRadius: _theme.radii.sm,
        colors: _objectSpread(_objectSpread({}, reactSelectTheme.colors), {}, {
          primary: _theme.colors.blue['400'],
          primary75: _theme.colors.blue['300'],
          primary50: _theme.colors.blue['200'],
          primary25: _theme.colors.gray['100'],
          danger: _theme.colors.red['400'],
          dangerLight: _theme.colors.red['300'],
          neutral0: _theme.colors.white,
          neutral5: _theme.colors.gray['100'],
          neutral10: _theme.colors.gray['200'],
          neutral20: _theme.colors.gray['300'],
          neutral30: _theme.colors.gray['400'],
          neutral40: _theme.colors.gray['500'],
          neutral50: _theme.colors.gray['600'],
          neutral60: _theme.colors.gray['700'],
          neutral70: _theme.colors.gray['800'],
          neutral80: _theme.colors.gray['900'],
          neutral90: _theme.colors.gray['1000']
        })
      });
    }
  };
};
exports.components = components;
exports["default"] = getReactSelectConfiguration;